module.exports = __webpack_public_path__ + "img/Download cloud Icon - white.789898ef.svg";